import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _45ac1d60 = () => interopDefault(import('../pages/500error.vue' /* webpackChunkName: "pages/500error" */))
const _61387dfc = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _5d7cf95d = () => interopDefault(import('../pages/career-advice/index.vue' /* webpackChunkName: "pages/career-advice/index" */))
const _cd54ece8 = () => interopDefault(import('../pages/career-development/index.vue' /* webpackChunkName: "pages/career-development/index" */))
const _1a6702a0 = () => interopDefault(import('../pages/job.vue' /* webpackChunkName: "pages/job" */))
const _0444b31f = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _1b5570ac = () => interopDefault(import('../pages/logout/index.vue' /* webpackChunkName: "pages/logout/index" */))
const _2fc49047 = () => interopDefault(import('../pages/myjob/index.vue' /* webpackChunkName: "pages/myjob/index" */))
const _9b5cd09a = () => interopDefault(import('../pages/myprofile/index.vue' /* webpackChunkName: "pages/myprofile/index" */))
const _e86534e8 = () => interopDefault(import('../pages/notFound.vue' /* webpackChunkName: "pages/notFound" */))
const _25ed1474 = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _48ed73f7 = () => interopDefault(import('../pages/privacy-policy/index.vue' /* webpackChunkName: "pages/privacy-policy/index" */))
const _778fa0d6 = () => interopDefault(import('../pages/privacy-policy/advertiser.vue' /* webpackChunkName: "pages/privacy-policy/advertiser" */))
const _25cfb459 = () => interopDefault(import('../pages/registration/index.vue' /* webpackChunkName: "pages/registration/index" */))
const _b724e11a = () => interopDefault(import('../pages/site-map.vue' /* webpackChunkName: "pages/site-map" */))
const _9cb8de0a = () => interopDefault(import('../pages/skills-training/index.vue' /* webpackChunkName: "pages/skills-training/index" */))
const _5e5764c4 = () => interopDefault(import('../pages/terms-conditions/index.vue' /* webpackChunkName: "pages/terms-conditions/index" */))
const _3040d26c = () => interopDefault(import('../pages/debug/androidFunc.vue' /* webpackChunkName: "pages/debug/androidFunc" */))
const _0f69e691 = () => interopDefault(import('../pages/debug/api.vue' /* webpackChunkName: "pages/debug/api" */))
const _256b0698 = () => interopDefault(import('../pages/debug/component.vue' /* webpackChunkName: "pages/debug/component" */))
const _cfd2b31c = () => interopDefault(import('../pages/debug/jobList.vue' /* webpackChunkName: "pages/debug/jobList" */))
const _b0492636 = () => interopDefault(import('../pages/debug/paging.vue' /* webpackChunkName: "pages/debug/paging" */))
const _5b14699d = () => interopDefault(import('../pages/debug/ui-component.vue' /* webpackChunkName: "pages/debug/ui-component" */))
const _5ea98d36 = () => interopDefault(import('../pages/login/activate.vue' /* webpackChunkName: "pages/login/activate" */))
const _1bc8a429 = () => interopDefault(import('../pages/login/forgot/index.vue' /* webpackChunkName: "pages/login/forgot/index" */))
const _8cb15b92 = () => interopDefault(import('../pages/login/resetpassword.vue' /* webpackChunkName: "pages/login/resetpassword" */))
const _f0bad60a = () => interopDefault(import('../pages/myjob/appliedjob.vue' /* webpackChunkName: "pages/myjob/appliedjob" */))
const _2612fb8c = () => interopDefault(import('../pages/myjob/follow.vue' /* webpackChunkName: "pages/myjob/follow" */))
const _be1b2c18 = () => interopDefault(import('../pages/myjob/invitation.vue' /* webpackChunkName: "pages/myjob/invitation" */))
const _b399404c = () => interopDefault(import('../pages/myjob/jobalert.vue' /* webpackChunkName: "pages/myjob/jobalert" */))
const _1dcee71e = () => interopDefault(import('../pages/myjob/savedjob.vue' /* webpackChunkName: "pages/myjob/savedjob" */))
const _7a710023 = () => interopDefault(import('../pages/myprofile/export.vue' /* webpackChunkName: "pages/myprofile/export" */))
const _70ce5038 = () => interopDefault(import('../pages/myprofile/landing.vue' /* webpackChunkName: "pages/myprofile/landing" */))
const _4be25ff1 = () => interopDefault(import('../pages/myprofile/setting.vue' /* webpackChunkName: "pages/myprofile/setting" */))
const _42e1ff41 = () => interopDefault(import('../pages/position/search.vue' /* webpackChunkName: "pages/position/search" */))
const _5cd5f7c2 = () => interopDefault(import('../pages/registration/activation.vue' /* webpackChunkName: "pages/registration/activation" */))
const _010d3bcc = () => interopDefault(import('../pages/social/callback.vue' /* webpackChunkName: "pages/social/callback" */))
const _5801b78f = () => interopDefault(import('../pages/terms-conditions/advertiser.vue' /* webpackChunkName: "pages/terms-conditions/advertiser" */))
const _1012b1cd = () => interopDefault(import('../pages/blog/cate/_slug/index.vue' /* webpackChunkName: "pages/blog/cate/_slug/index" */))
const _08a8a7ee = () => interopDefault(import('../pages/blog/page/_page.vue' /* webpackChunkName: "pages/blog/page/_page" */))
const _07fe0d1e = () => interopDefault(import('../pages/blog/post/_slug/index.vue' /* webpackChunkName: "pages/blog/post/_slug/index" */))
const _23579bcc = () => interopDefault(import('../pages/login/backend/_id.vue' /* webpackChunkName: "pages/login/backend/_id" */))
const _bbf00c1e = () => interopDefault(import('../pages/myjob/applicationsubmitted/_id.vue' /* webpackChunkName: "pages/myjob/applicationsubmitted/_id" */))
const _09ef610e = () => interopDefault(import('../pages/myjob/apply/_id.vue' /* webpackChunkName: "pages/myjob/apply/_id" */))
const _2ced922d = () => interopDefault(import('../pages/myjob/nonmemberapplyreg/_id.vue' /* webpackChunkName: "pages/myjob/nonmemberapplyreg/_id" */))
const _5db364ac = () => interopDefault(import('../pages/position/preview/_id.vue' /* webpackChunkName: "pages/position/preview/_id" */))
const _00df093a = () => interopDefault(import('../pages/article-search/_slug/index.vue' /* webpackChunkName: "pages/article-search/_slug/index" */))
const _2ee57832 = () => interopDefault(import('../pages/article/_slug/index.vue' /* webpackChunkName: "pages/article/_slug/index" */))
const _e6bb2342 = () => interopDefault(import('../pages/career-advice/_cat/index.vue' /* webpackChunkName: "pages/career-advice/_cat/index" */))
const _3d252e85 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _120ee236 = () => interopDefault(import('../pages/position/search.vue' /* webpackChunkName: "" */))
const _3da26454 = () => interopDefault(import('../pages/job.vue' /* webpackChunkName: "" */))
const _2c370b16 = () => interopDefault(import('../pages/article-search/_slug/index.vue' /* webpackChunkName: "" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/500error",
    component: _45ac1d60,
    name: "500error"
  }, {
    path: "/blog",
    component: _61387dfc,
    name: "blog"
  }, {
    path: "/career-advice",
    component: _5d7cf95d,
    name: "career-advice"
  }, {
    path: "/career-development",
    component: _cd54ece8,
    name: "career-development"
  }, {
    path: "/job",
    component: _1a6702a0,
    name: "job"
  }, {
    path: "/login",
    component: _0444b31f,
    name: "login"
  }, {
    path: "/logout",
    component: _1b5570ac,
    name: "logout"
  }, {
    path: "/myjob",
    component: _2fc49047,
    name: "myjob"
  }, {
    path: "/myprofile",
    component: _9b5cd09a,
    name: "myprofile"
  }, {
    path: "/notFound",
    component: _e86534e8,
    name: "notFound"
  }, {
    path: "/privacy-policy",
    component: _25ed1474,
    children: [{
      path: "",
      component: _48ed73f7,
      name: "privacy-policy"
    }, {
      path: "advertiser",
      component: _778fa0d6,
      name: "privacy-policy-advertiser"
    }]
  }, {
    path: "/registration",
    component: _25cfb459,
    name: "registration"
  }, {
    path: "/site-map",
    component: _b724e11a,
    name: "site-map"
  }, {
    path: "/skills-training",
    component: _9cb8de0a,
    name: "skills-training"
  }, {
    path: "/terms-conditions",
    component: _5e5764c4,
    name: "terms-conditions"
  }, {
    path: "/debug/androidFunc",
    component: _3040d26c,
    name: "debug-androidFunc"
  }, {
    path: "/debug/api",
    component: _0f69e691,
    name: "debug-api"
  }, {
    path: "/debug/component",
    component: _256b0698,
    name: "debug-component"
  }, {
    path: "/debug/jobList",
    component: _cfd2b31c,
    name: "debug-jobList"
  }, {
    path: "/debug/paging",
    component: _b0492636,
    name: "debug-paging"
  }, {
    path: "/debug/ui-component",
    component: _5b14699d,
    name: "debug-ui-component"
  }, {
    path: "/login/activate",
    component: _5ea98d36,
    name: "login-activate"
  }, {
    path: "/login/forgot",
    component: _1bc8a429,
    name: "login-forgot"
  }, {
    path: "/login/resetpassword",
    component: _8cb15b92,
    name: "login-resetpassword"
  }, {
    path: "/myjob/appliedjob",
    component: _f0bad60a,
    name: "myjob-appliedjob"
  }, {
    path: "/myjob/follow",
    component: _2612fb8c,
    name: "myjob-follow"
  }, {
    path: "/myjob/invitation",
    component: _be1b2c18,
    name: "myjob-invitation"
  }, {
    path: "/myjob/jobalert",
    component: _b399404c,
    name: "myjob-jobalert"
  }, {
    path: "/myjob/savedjob",
    component: _1dcee71e,
    name: "myjob-savedjob"
  }, {
    path: "/myprofile/export",
    component: _7a710023,
    name: "myprofile-export"
  }, {
    path: "/myprofile/landing",
    component: _70ce5038,
    name: "myprofile-landing"
  }, {
    path: "/myprofile/setting",
    component: _4be25ff1,
    name: "myprofile-setting"
  }, {
    path: "/position/search",
    component: _42e1ff41,
    name: "position-search"
  }, {
    path: "/registration/activation",
    component: _5cd5f7c2,
    name: "registration-activation"
  }, {
    path: "/social/callback",
    component: _010d3bcc,
    name: "social-callback"
  }, {
    path: "/terms-conditions/advertiser",
    component: _5801b78f,
    name: "terms-conditions-advertiser"
  }, {
    path: "/blog/cate/:slug",
    component: _1012b1cd,
    name: "blog-cate-slug"
  }, {
    path: "/blog/page/:page?",
    component: _08a8a7ee,
    name: "blog-page-page"
  }, {
    path: "/blog/post/:slug",
    component: _07fe0d1e,
    name: "blog-post-slug"
  }, {
    path: "/login/backend/:id?",
    component: _23579bcc,
    name: "login-backend-id"
  }, {
    path: "/myjob/applicationsubmitted/:id?",
    component: _bbf00c1e,
    name: "myjob-applicationsubmitted-id"
  }, {
    path: "/myjob/apply/:id?",
    component: _09ef610e,
    name: "myjob-apply-id"
  }, {
    path: "/myjob/nonmemberapplyreg/:id?",
    component: _2ced922d,
    name: "myjob-nonmemberapplyreg-id"
  }, {
    path: "/position/preview/:id?",
    component: _5db364ac,
    name: "position-preview-id"
  }, {
    path: "/article-search/:slug",
    component: _00df093a,
    name: "article-search-slug"
  }, {
    path: "/article/:slug",
    component: _2ee57832,
    name: "article-slug"
  }, {
    path: "/career-advice/:cat",
    component: _e6bb2342,
    name: "career-advice-cat"
  }, {
    path: "/",
    component: _3d252e85,
    name: "index"
  }, {
    path: "/position/search",
    component: _120ee236,
    alias: "/industry/:industry-jobs/:page",
    name: "industry"
  }, {
    path: "/position/search",
    component: _120ee236,
    alias: "/search-:keyword-jobs/:page",
    name: "jobsearch"
  }, {
    path: "/position/search",
    component: _120ee236,
    alias: "/company-:keyword-jobs/:page",
    name: "companysearch"
  }, {
    path: "/position/search",
    component: _120ee236,
    alias: ["/jobs/:field/:subfield/:page","/jobs/:field/:page"],
    name: "jobfunction"
  }, {
    path: "/position/search",
    component: _120ee236,
    alias: "/location/:location-jobs/:page",
    name: "location"
  }, {
    path: "/position/search",
    component: _120ee236,
    alias: "/work-type/:worktype-jobs/:page",
    name: "worktype"
  }, {
    path: "/position/search",
    component: _120ee236,
    alias: "/campaign/:campaign",
    name: "campaign"
  }, {
    path: "/position/search",
    component: _120ee236,
    alias: "/job-level/:joblevel-level-jobs/:page",
    name: "joblevel"
  }, {
    path: "/position/search",
    component: _120ee236,
    alias: "/SearchJobs",
    name: "searchjobs"
  }, {
    path: "/position/search",
    component: _120ee236,
    alias: "/SearchJobs/:page",
    name: "searchjobs-page"
  }, {
    path: "/job/:id",
    component: _3da26454,
    name: "job-page"
  }, {
    path: "/job/preview/:id",
    component: _3da26454,
    name: "job-preview-page"
  }, {
    path: "/article-search/:slug",
    component: _2c370b16,
    alias: "/tags/:slug",
    name: "tags-page"
  }, {
    path: "/article-search/:slug",
    component: _2c370b16,
    alias: "/author/:slug",
    name: "author-page"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decode(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
